export enum StepEnum {
  Auth,
  AuthFail,
  AuthOTPSelection,
  AuthOTPValidation,
}
